// extracted by mini-css-extract-plugin
export var activeFilterButton = "_re-c";
export var backButton = "_re-4";
export var backIcon = "_re-5";
export var chevronShortcut = "_re-6";
export var container = "_re-1";
export var editor = "_re-8";
export var editorWrapper = "_re-7";
export var prefix = "_re-2";
export var searchIcon = "_re-3";
export var suffix = "_re-9";
export var suffixContent = "_re-a";
export var suffixText = "_re-b";
export var wrapper = "_re-0";